<template>
    <div class="min-h-screen relative">
        <div class="relative"> 
          <main class="text-neutral-800">
                  <slot /> 
          </main>  
        </div>
      </div>
  </template>
  <script>
  export default {
    name: 'PrintLayout',
  }
  </script>
  <script setup>
  const { isMobile } = useDevice();
  </script>
  <style>
  html {
    padding: 0;
    margin:0;
  }
  body {
    padding: 0;
    margin:0;
  }
  </style>
  <style>@import "~/assets/css/default.css"; @import "~/assets/css/main.css";</style>
  <style lang="scss">@import "~/assets/css/main.scss";</style>
